import {Badge, BadgeProps} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

interface Props extends BadgeProps {
  status?: string | null
}

const StatusToColorMap: Record<string, BadgeProps['colorPalette']> = {
  active: 'green',
  inactive: 'red',
  error: 'red',
  skipped: 'orange',
}

const StatusToBorderMap: Record<string, BadgeProps['borderColor']> = {
  active: 'green.muted',
  inactive: 'red.muted',
  error: 'red.muted',
  skipped: 'orange.muted',
}

export function ResourceStatus({status, children, ...props}: Props) {
  const {t} = useTranslate('common')

  let color: BadgeProps['colorPalette'] = status ? StatusToColorMap[status] : undefined
  if (!color) color = 'gray'

  const borderColor = status ? StatusToBorderMap[status] : undefined
  const borderProps = borderColor ? {borderStyle: 'solid', borderWidth: '1px', borderColor} : undefined

  return (
    <Badge size="sm" variant="subtle" colorPalette={color} py="1" {...borderProps} {...props}>
      {t(status?.toLowerCase() || 'default')}
      {children}
    </Badge>
  )
}
